import { ProxyServerType } from "@fd/common/biz/proxyType";
import { z } from "zod";
import { normalize } from "../normalize";
import { httpApi } from "./basicHttpApi";

export const TimeGologinComResponceZod = z.object({
  "country": z.string(),
  "stateProv": z.string(),
  "city": z.string(),
  "timezone": z.string(),
  "ll": z.string().array().length(2),
  "languages": z.string(),
  "accuracy": z.number(),
  "ip": z.string().ip(),
});
export type TimeGologinComResponceType = z.infer<typeof TimeGologinComResponceZod>;
export type CheckProxyReturnType = TimeGologinComResponceType | 'notraffic' | 'failed';

export const checkProxy = async (proxy: ProxyServerType, protocol: string = 'http'): Promise<CheckProxyReturnType> => {
  const result = await httpApi('proxy/check', {
    host: proxy.host,
    port: proxy.port,
    username: proxy.username,
    password: proxy.password,
    protocol
  });
  console.log('checkProxy', result);
  if (result.httpStatus === 402) {
    return 'notraffic';
  }
  if (result.httpStatus >= 400) {
    return 'failed';
  }
  return normalize(TimeGologinComResponceZod, result);
}

/*

/v1/proxy/check
аутентификация нужна, в теле прокси в таком же формате, как возвращается из одиночного создания прокси, но используются юзернейм, пароль, хост и порт. В ответ возвращается то, что вернул time.gologin.com
{
    "username": "F6U8FqHdzXFkvAUY",
    "password": "aLflAOxdUxeI4p0Q",
    "host": "geo.floppydata.com",
    "port": 10080
}
{
  "country":"US",
  "stateProv":"Florida",
  "city":"Davenport",
  "timezone":"America/New_York",
  "ll":["28.19510","-81.60620"],
  "languages":"en",
  "accuracy":100,
  "ip":"173.169.151.93",

*/